$(document).ready(function () {
  $(".bridgman--sort--container li.cursor ").on("click", function (e) {
    let thisValue = $(this).attr("value");
    let selectBox = $("#SortBy.facet-filters__sort");
    let selectBoxOption = selectBox.children("option");

    $("#SortBy.facet-filters__sort option").each(function () {
      selectBoxOption.removeAttr("selected");
      if (thisValue === $(this).val()) {
        $(this).val(thisValue).attr("selected", "selected");
      }
    });
  });
  $(
    ".price-filter-mobile .js--num, .price-filter-mobile .js--qty-adjuster",
  ).click(function (e) {
    e.stopPropagation();
  });

  // ================================ Hidden Image Popup ================================

  $(".hidden-product-image-button").on("click", function (e) {
    e.stopPropagation();
    $(".popupinfo").addClass("openpopup");
    $(".overlay").addClass("active");
    $("html").addClass("collectioniconpopup");
  });
  $(".close").on("click", function () {
    $(".popupinfo").removeClass("openpopup");
    $(".overlay").removeClass("active");
    $("html").removeClass("collectioniconpopup");
  });

  $(".option-okay").on("click", function () {
    $(".popupinfo").removeClass("openpopup");
    $(".overlay").removeClass("active");
    $("html").removeClass("collectioniconpopup");
    $(".bridgman-hidden-product-image-overlay").addClass("hidden");
  });

  // ================== hide popup on click outside ================

  $(".overlay").click(function () {
    $(".bridgman-hidden-product-image-overlay").addClass("hidden");
    $(".overlay").removeClass("active");
  });

  // ========================== Hidden Image Slider ===========================

  $(".model-slide-items").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: true,
    asNavFor: ".slider-nav",
    adaptiveHeight: true,
  });
  $(".slider-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".model-slide-items",
    focusOnSelect: true,
    adaptiveHeight: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // ==================== Refresh slick slider on popup open =================
  $(".hidden-product-image-button").on("click", function () {
    $(".model-slide-items").slick("refresh");
  });

  $(".brid-flex .variant li span").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (!$(this).data("media")) return;
    $(this)
      .parents(".bridgman-product-card-container")
      .find(".prod-card-img")
      .attr("src", $(this).data("media"));
  });
});

function showHiddenImagePopUp() {
  var popUpContainer = document.querySelector(
    ".bridgman-hidden-product-image-overlay",
  );

  popUpContainer.classList.remove("hidden");
}

function closeHiddenImagePopup() {
  var popUpContainer = document.querySelector(
    ".bridgman-hidden-product-image-overlay",
  );

  popUpContainer.classList.add("hidden");
}

function bridgamAddToCart(data) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (cart) {
      var desktop_cart_count = $(".desktop-only .cart-count").text();
      desktop_cart_count = parseInt(desktop_cart_count);

      if (
        $(".desktop-only .cart-count, #mobileNavBar .cart-count").hasClass(
          "hidden-count",
        )
      ) {
        $(".desktop-only .cart-count, #mobileNavBar .cart-count").removeClass(
          "hidden-count",
        );
      }
      $(".desktop-only .cart-count,#mobileNavBar .cart-count").text(
        desktop_cart_count + 1,
      );
      //$("#ajax_cart__drawer").html(cart.sections['ajax-cart-drawer-section']);
      $(".ajax-brid-addtocart")
        .find('input[type="submit"]')
        .val("Add to your basket");
    },
    error: function (XMLHttpRequest, textStatus) {},
  };
  jQuery.ajax(params);
}

/****** Announcement bar Count Down ******/
if (document.getElementById("countDownTime")) {
  var times = document
    .getElementById("countDownTime")
    .getAttribute("data-times");
  var countDownDate = new Date(times).getTime();
  var x = setInterval(function () {
    var now = new Date().getTime();

    var distance = countDownDate - now;

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("countDownTime").innerHTML =
      days + "d : " + hours + "h : " + minutes + "m : " + seconds + "s ";

    if (distance < 0) {
      clearInterval(x);
      document.getElementById("countDownTime").innerHTML = "EXPIRED";
    }
  }, 1000);
}
/****** End Announcement bar Count Down ******/

$(document).ready(function () {
  $(".where_you_hear").on("change", function () {
    $(this).parents("form").find(".bridgman-catalogue_other").addClass("hide");
    $(this)
      .parents("form")
      .find(".bridgman-catalogue_other")
      .removeAttr("required");

    if ($(this).val() == "Other") {
      $(this)
        .parents("form")
        .find(".bridgman-catalogue_other")
        .attr("required", "true");
      $(this)
        .parents("form")
        .find(".bridgman-catalogue_other")
        .removeClass("hide");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var whatsappButtonImg = document.querySelector(".whatsapp-button");
  if (whatsappButtonImg) {
    setTimeout(function () {
      whatsappButtonImg.classList.add("animate");
    }, 100);
  }

  // event listener to close button
  var closeBtn = document.querySelector(".whatsapp-button .close-btn");
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var whatsappButton = e.target.closest(".whatsapp-button");
      if (whatsappButton) {
        whatsappButton.classList.add("close-animate");
        //need this for listening to transition ending
        whatsappButton.addEventListener("transitionend", function () {
          if (whatsappButton.parentNode) {
            whatsappButton.parentNode.removeChild(whatsappButton);
          }
        });
      }
    });
  }
});
